/* global routes */

const SELECTORS = {
  cartItemsWrapper: 'cart-items',
  cartFooter: 'main-cart-footer',
  variantSelector: '.cart-variant-selects',
  select: '.cart-variant-selects__select',
  lineItem: '.cart-item',
};
globalThis.updateCartVariant = {
  /**
   * Get dom elements
   */
  cacheDOM() {
    this.dom = {};
    this.dom.cartItemsWrapper = document.querySelector(SELECTORS.cartItemsWrapper);
    this.dom.cartFooter = document.getElementById(SELECTORS.cartFooter);
    this.dom.lineItems = this.dom.cartItemsWrapper.querySelectorAll(SELECTORS.lineItem);
    this.postConfig = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };
  },

  /**
   * Event listenrs
   */
  eventListeners() {
    if (this.dom.lineItems && this.dom.lineItems.length > 0) {
      this.dom.lineItems.forEach((lineItem) => {
        const sizeSelects = lineItem.querySelectorAll(SELECTORS.select);
        sizeSelects.forEach((sizeSelect) => {
          sizeSelect.addEventListener('change', async () => {
            await this.updateCart(lineItem, sizeSelect);
          });
        });
      });
    }
  },

  /**
   * Init update cart items
   *
   * @param {HTMLElement} lineItem wrapper
   * @param {HTMLSelectElement} sizeSelect size select
   */
  async updateCart(lineItem, sizeSelect) {
    try {
      const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
      const variantId = +selectedOption.getAttribute('data-variant-id');
      const lineItemQuantityInput = parseInt(lineItem.querySelector('[data-cart-quantity]')?.getAttribute('data-cart-quantity'), 10);

      if (!variantId) {
        console.error('Variant ID not found for selected option.');
        return;
      }
      const cartItemExist = this.dom.cartItemsWrapper.querySelector(`${SELECTORS.lineItem}[data-variant-id="${variantId}"]`)
        ? this.dom.cartItemsWrapper.querySelector(`${SELECTORS.lineItem}[data-variant-id="${variantId}"]`)
        : false;
      // Do something with cartData here
      if (cartItemExist) {
        // const existItemQuantity = parseInt(cartItemExist.querySelector('[data-cart-quantity]')?.getAttribute('data-cart-quantity'), 10);
        this.enableLoading(lineItem.dataset.itemIndex);
        this.removeFromCart(lineItem.dataset.itemIndex, '0').then(() => {
          this.addToCart(variantId, lineItemQuantityInput);
        });
        // Do something with itemQuantity
      } else {
        this.enableLoading(lineItem.dataset.itemIndex);
        this.removeFromCart(lineItem.dataset.itemIndex, '0').then(() => {
          this.addToCart(variantId, lineItemQuantityInput);
        });
      }
    } catch (error) {
      console.error('Error:', error);
    }
  },
  /**
   * Get current cart data
   */
  async getCart() {
    try {
      const response = await fetch(`${routes.cart_url}.js`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error('Failed to fetch cart data');
      }
      return response.json();
    } catch (error) {
      throw new Error(`Error fetching cart data: ${error.message}`);
    }
  },

  /**
   * @param {number} id variant id
   * @param {number} quantity quantity
   */
  addToCart(id, quantity) {
    const formData = {
      items: [
        {
          id,
          quantity,
        },
      ],
    };
    fetch(`${routes.cart_add_url}.js`, {
      ...this.postConfig,
      body: JSON.stringify(formData),
    })
      .then(() => {
        this.renderCartItems();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  },

  /**
   * @param {number} id variant id
   * @param {number} quantity quantity
   */
  updateAlreadyExsistLineItem(id, quantity) {
    const formData = {
      items: [
        {
          id,
          quantity,
        },
      ],
    };
    fetch(`${routes.cart_update_url}.js`, {
      ...this.postConfig,
      body: JSON.stringify(formData),
    })
      .then(() => {
        this.renderCartItems();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  },

  /**
   * Remove item from cart
   *
   * @param {number} line lineItem index
   * @param {number} quantity quantity
   * @returns {Promise} promsie
   */
  async removeFromCart(line, quantity) {
    const body = JSON.stringify({
      line,
      quantity,
    });
    const response = await fetch(`${routes.cart_change_url}.js`, {
      ...this.postConfig,
      body,
    });
    return response;
  },

  /**
   * Get html & render
   */
  renderCartItems() {
    const fetchRequests = [
      fetch(`${routes.cart_url}?section_id=${document.getElementById('main-cart-items').dataset.id}`),
      fetch(`${routes.cart_url}?section_id=${document.getElementById('main-cart-footer').dataset.id}`),
    ];

    // Execute both fetch requests concurrently
    Promise.all(fetchRequests)
      .then((responses) => {
        // Extract response texts from the resolved promises
        return Promise.all(responses.map((response) => response.text()));
      })
      .then((responseTexts) => {
        const mainCartItemsHtml = new DOMParser().parseFromString(responseTexts[0], 'text/html');
        const mainCartFooterHtml = new DOMParser().parseFromString(responseTexts[1], 'text/html');

        // Update cart items wrapper
        const sourceQty = mainCartItemsHtml.querySelector('cart-items');
        this.dom.cartItemsWrapper.innerHTML = sourceQty.innerHTML;
        this.init();

        // Update cart footer content
        const content = mainCartFooterHtml.querySelector('.js-contents');
        this.dom.cartFooter.querySelector('.js-contents').innerHTML = content.innerHTML;
      })
      .catch((error) => {
        console.error(error);
      });
  },

  /**
   * @param {number} line line
   */
  enableLoading(line) {
    const lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = mainCartItems.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = mainCartItems.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    lineItemStatusElement.setAttribute('aria-hidden', false);
  },
  /**
   * Init methods
   */
  init() {
    this.cacheDOM();
    this.eventListeners();
  },
};
document.addEventListener('DOMContentLoaded', () => {
  globalThis.updateCartVariant.init();
});
